'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Checkbox = require('../../lib/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = require('merge-theme-hoc');

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'hiddenInput': 'Checkbox__hiddenInput___2Ugww',
  'container': 'Checkbox__container___wO1uF',
  'label': 'Checkbox__label___25y9M',
  'labelContainerDisabled': 'Checkbox__labelContainerDisabled___1r24R',
  'labelDisabled': 'Checkbox__labelDisabled___30VEp',
  'children': 'Checkbox__children___30LWU',
  'childrenDisabled': 'Checkbox__childrenDisabled___3iTW5',
  'checkbox': 'Checkbox__checkbox___3AZdc',
  'checkboxUnchecked': 'Checkbox__checkboxUnchecked___1KJ60',
  'checkmark': 'Checkbox__checkmark___3Lp1U',
  'checkboxDisabled': 'Checkbox__checkboxDisabled___1-kNB',
  'checkboxChecked': 'Checkbox__checkboxChecked___26445'
};

var CircleCheckbox = (0, _mergeThemeHoc2.default)(style)(_Checkbox2.default);
CircleCheckbox.displayName = 'CircleCheckbox';
exports.default = CircleCheckbox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/dist/Checkbox/Circle.js
// module id = ./node_modules/dibs-elements/dist/Checkbox/Circle.js
// module chunks = 4